/* BANGA: sends the whole cart to the COD backend. The backend works out the price again from Shopify. */
(function () {
  var box = document.querySelector('[data-banga-order]');
  var form = box && box.querySelector('[data-order-form]');
  if (!form) return;

  var startedAt = Date.now();
  var requestId = '';
  var sending = false;
  var button = form.querySelector('.bco__submit');
  var errorBox = box.querySelector('[data-order-error]');
  var lines = JSON.parse(box.querySelector('[data-order-lines]').textContent);
  var MESSAGES = {
    required: 'لازم تعمّر الخانات الكل.',
    phone: 'ثبّت في نومرو التليفون.',
    duplicate: 'عندك كوموند بنفس النومرو هاذا.',
    stock: 'موديل من هاذوما موش متوفّر توّة.',
    error: 'صارت مشكلة، عاود جرّب.',
  };

  function contentIds() {
    return lines.map(function (l) { return String(l.productId); });
  }
  function count() {
    return lines.reduce(function (s, l) { return s + l.quantity; }, 0);
  }
  function id() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return Date.now() + '-' + Math.random().toString(36).slice(2);
  }
  function value(name) {
    return (form.elements[name].value || '').trim();
  }
  function cookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function phone() {
    var digits = value('phone').replace(/\D/g, '');
    var code = box.dataset.phoneCode;
    if (digits.indexOf('00' + code) === 0) digits = digits.slice(code.length + 2);
    else if (digits.indexOf(code) === 0 && digits.length > Number(box.dataset.phoneDigits)) digits = digits.slice(code.length);
    return digits.length === Number(box.dataset.phoneDigits) ? '+' + code + digits : '';
  }
  function attrib() {
    try {
      var saved = JSON.parse(localStorage.getItem('lx-attrib') || 'null');
      if (saved && Date.now() - (saved.at || 0) < 30 * 86400000) return saved;
    } catch (e) {}
    return {};
  }
  function showError(text) {
    errorBox.textContent = text;
    errorBox.hidden = !text;
  }
  function busy(on) {
    sending = on;
    button.disabled = on;
    button.textContent = on ? button.dataset.loading : button.dataset.label;
  }
  async function post(body) {
    try {
      var res = await fetch(box.dataset.backend, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(body),
      });
      return await res.json();
    } catch (e) {
      return { ok: false, error: 'network' };
    }
  }
  function validate() {
    var ok = true;
    form.querySelectorAll('.bco__field').forEach(function (field) {
      var el = field.querySelector('input, select');
      var bad = !el.value.trim() || (el.name === 'phone' && !phone());
      field.classList.toggle('is-invalid', bad);
      if (bad) ok = false;
    });
    if (!ok) showError(value('phone') && !phone() ? MESSAGES.phone : MESSAGES.required);
    return ok;
  }

  // Free hoodie picker: shown when the cart has 2 hoodies and the third is still to choose
  var ADDED_KEY = 'banga-free-added';
  var pick = box.querySelector('[data-free-pick]');
  if (pick) {
    var catalog = JSON.parse(box.querySelector('[data-free-catalog]').textContent);
    var modelSelect = pick.querySelector('[data-free-model]');
    var sizeSelect = pick.querySelector('[data-free-size]');
    var picture = pick.querySelector('img');
    var fillSizes = function () {
      var product = catalog.find(function (p) { return String(p.id) === modelSelect.value; });
      sizeSelect.innerHTML = '';
      var chosen = false;
      product.variants.forEach(function (v) {
        var o = document.createElement('option');
        o.value = v.id;
        o.textContent = v.title;
        o.disabled = !v.available;
        if (v.available && !chosen) {
          o.selected = true;
          chosen = true;
        }
        sizeSelect.appendChild(o);
      });
      showPicture();
    };
    var showPicture = function () {
      var product = catalog.find(function (p) { return String(p.id) === modelSelect.value; });
      var v = product.variants.find(function (x) { return String(x.id) === sizeSelect.value; });
      if (v && v.image) picture.src = v.image;
    };
    catalog.forEach(function (p) {
      var o = document.createElement('option');
      o.value = p.id;
      o.textContent = p.title;
      modelSelect.appendChild(o);
    });
    fillSizes();
    modelSelect.addEventListener('change', fillSizes);
    sizeSelect.addEventListener('change', showPicture);
    pick.querySelector('button').addEventListener('click', async function (e) {
      var add = e.currentTarget;
      add.disabled = true;
      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(sizeSelect.value), quantity: 1 }),
        });
        if (!res.ok) throw new Error('add failed');
        try { sessionStorage.setItem(ADDED_KEY, '1'); } catch (err) {}
        location.reload();
      } catch (err) {
        add.disabled = false;
        showError(MESSAGES.stock);
      }
    });
  }

  // InitiateCheckout from the browser and the server, with the same ID so Meta counts it once.
  // Adding the free hoodie reloads this page: that is still the same checkout, so it is not sent again.
  var initiateId = id();
  var checkoutValue = Number(box.dataset.total);
  var reloaded = false;
  try {
    reloaded = sessionStorage.getItem(ADDED_KEY) === '1';
    sessionStorage.removeItem(ADDED_KEY);
  } catch (e) {}
  if (!reloaded) {
    if (window.fbq) {
      window.fbq('track', 'InitiateCheckout', { value: checkoutValue, currency: box.dataset.currency, content_type: 'product', content_ids: contentIds(), num_items: count() }, { eventID: initiateId });
    }
    post({
      shop: box.dataset.shop, action: 'event', template: 'product', sectionId: 'cod_form', eventName: 'InitiateCheckout', eventId: initiateId,
      value: checkoutValue, productId: lines[0].productId, quantity: count(), page: location.href,
      meta: { fbp: cookie('_fbp'), fbc: cookie('_fbc'), userAgent: navigator.userAgent, page: location.href, attrib: attrib() },
    });
  }

  // Before the order: if a free hoodie is still open, remind the customer once. Closing the popup stays on the form.
  var offerAnswered = false;
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (sending) return;
    showError('');
    if (!validate()) return;
    var left = count() % 3;
    if (left && !offerAnswered && window.BangaOffer) {
      var prices = [];
      lines.forEach(function (l) {
        for (var i = 0; i < l.quantity; i++) prices.push(l.price);
      });
      window.BangaOffer.open({
        needed: 3 - left,
        basePrices: prices,
        defaultProductId: lines[0].productId,
        onAccept: function (picks) {
          offerAnswered = true;
          picks.forEach(function (p) {
            var same = lines.find(function (l) { return l.variantId === p.variantId; });
            if (same) same.quantity += 1;
            else lines.push({ variantId: p.variantId, productId: p.productId, quantity: 1 });
          });
          window.BangaOffer.close();
          send();
        },
        onSkip: function () {
          offerAnswered = true;
          send();
        },
      });
      return;
    }
    send();
  });

  async function send() {
    busy(true);
    requestId = requestId || id();
    var body = {
      shop: box.dataset.shop,
      action: 'order',
      cart: true,
      template: 'product',
      sectionId: 'cod_form',
      requestId: requestId,
      eventId: requestId,
      lines: lines,
      customer: { name: value('name'), phone: phone(), region: value('region'), city: value('city'), address: value('address') },
      meta: { fbp: cookie('_fbp'), fbc: cookie('_fbc'), userAgent: navigator.userAgent, page: location.href, attrib: attrib() },
      honeypot: value('trap'),
      elapsedMs: Date.now() - startedAt,
    };
    var res = await post(body);
    if (!res || res.error === 'network' || res.error === 'server_error') {
      await new Promise(function (r) { setTimeout(r, 1500); });
      res = await post(body);
    }
    if (res && res.ok) {
      if (window.fbq) {
        window.fbq('track', 'Purchase', { value: Number(res.total) || checkoutValue, currency: box.dataset.currency, content_type: 'product', content_ids: contentIds(), num_items: count() }, { eventID: requestId });
      }
      fetch('/cart/clear.js', { method: 'POST' }).catch(function () {});
      var done = box.querySelector('[data-order-done]');
      box.querySelector('[data-order-thanks]').textContent = done.dataset.thanks.replace('{order}', res.orderName || '');
      box.querySelector('[data-order-body]').hidden = true;
      done.hidden = false;
      return;
    }
    busy(false);
    var known = { duplicate: MESSAGES.duplicate, invalid_phone: MESSAGES.phone, out_of_stock: MESSAGES.stock, missing_name: MESSAGES.required };
    showError((res && known[res.error]) || MESSAGES.error);
  }
})();
